/**
 * Part of the LA-Clinic roll out, we are temporarily providing
 * users the choice of two clinics. The LA clinic will redirect
 * users away from our site, so this is temporary.
 */
import { TemporaryClinic, EnvironmentType } from '../types';
import { labs } from './lab.helper';
import invert from 'lodash.invert';

const clinicLocations: Array<TemporaryClinic> = [
  {
    id: 'MIDTOWN',
    name: 'Midtown',
    address: {
      name: '',
      street1: '693 5th Ave',
      street2: '7th Floor',
      city: 'New York',
      state: 'NY'
    }
  },
  {
    id: 'WESTWOOD',
    name: 'Westwood',
    address: {
      name: 'CMD Fertility (Kindbody Partner)',
      street1: '10921 Wilshire Blvd',
      street2: '#702',
      city: 'Los Angeles',
      state: 'CA'
    }
  }
];

const KBContacts = {
  employeeBenefitsEmail: 'employeebenefits@kindbody.com',
  defaultNumber: '018555632639',
  navigatorEmail: 'navigator@kindbody.com',
  navigatorNumber: '+01-855-563-2639',
  nyCyclingEmail: 'cycling@kindbody.com',
  nyCyclingNumber: '+01-855-563-2639',
  nyWhatsappNumber: '+01-628-629-2436',
  sfCyclingEmail: 'cyclingsf@kindbody.com',
  sfCyclingNumber: '+01-628-219-1215',
  sfWhatsappNumber: '+01-628-219-1215',
  laCyclingEmail: 'cycling.la@kindbody.com',
  laCyclingNumber: '+01-213-839-6979',
  laWhatsappNumber: '+01-310-857-9390',
  minneapolisWhatsappNumber: '+01-415-940-0894',
  losAltosWhatsappNumber: '+01-650-407-4181',
  atlantaWhatsappNumber: '+01-470-453-6446',
  austinWhatsappNumber: '+01-737-268-8838',
  disneyCyclingNumber: '+01-407-934-4100',
  disneyCyclingEmail: 'CLW.Gaea@kindbody.com',
  clinical: 'clinical@kindbody.com',
  clinicLocations
};

const LABS = Object.freeze({
  NONE: {
    numberLabel: '855 KND BODY',
    number: KBContacts.navigatorNumber,
    email: KBContacts.navigatorEmail
  },
  NY: {
    numberLabel: KBContacts.nyCyclingNumber.replace('-', ' ').slice(4),
    number: KBContacts.nyCyclingNumber,
    email: KBContacts.nyCyclingEmail
  },
  SF: {
    numberLabel: KBContacts.sfCyclingNumber.replace('-', ' ').slice(4),
    number: KBContacts.sfCyclingNumber,
    email: KBContacts.sfCyclingEmail
  },
  LA: {
    numberLabel: KBContacts.laCyclingNumber.replace('-', ' ').slice(4),
    number: KBContacts.laCyclingNumber,
    email: KBContacts.laCyclingEmail
  },
  DISNEY: {
    numberLabel: KBContacts.disneyCyclingNumber.replace('-', ' ').slice(4),
    number: KBContacts.disneyCyclingNumber,
    email: KBContacts.disneyCyclingEmail
  },
  LOS_ALTOS: {
    numberLabel: '855 KND BODY',
    number: KBContacts.navigatorNumber,
    email: KBContacts.navigatorEmail
  },
  ATLANTA: {
    numberLabel: '855 KND BODY',
    number: KBContacts.navigatorNumber,
    email: KBContacts.navigatorEmail
  },
  AUSTIN: {
    numberLabel: '855 KND BODY',
    number: KBContacts.navigatorNumber,
    email: KBContacts.navigatorEmail
  },
  MINNEAPOLIS: {
    numberLabel: '855 KND BODY',
    number: KBContacts.navigatorNumber,
    email: KBContacts.navigatorEmail
  }
});

export function getLabInfo(labId: string, env: EnvironmentType) {
  const labsForEnvMap = labs(env);
  // Reverse keys/values
  const inverted = invert(labsForEnvMap);
  //@ts-ignore
  const locationAbbreviation: 'NONE' | 'NY' | 'SF' | 'LA' = inverted[labId] || 'NONE';
  const contactInfo = locationAbbreviation && LABS[locationAbbreviation];
  return (
    contactInfo || {
      numberLabel: '855 KND BODY',
      number: KBContacts.navigatorNumber,
      email: KBContacts.navigatorEmail
    }
  );
}

export default KBContacts;
